import api, { unwrap } from '../client';

export const listCostPools  = (tenantId)            => unwrap(api.get(`/tdabc/cost-pools/${tenantId}`));
export const createCostPool = (tenantId, payload)   => unwrap(api.post(`/tdabc/cost-pools/${tenantId}`, payload));
export const patchCostPool  = (tenantId, id, patch) => unwrap(api.patch(`/tdabc/cost-pools/${tenantId}/${id}`, patch));
export const deleteCostPool = (tenantId, id)        => unwrap(api.delete(`/tdabc/cost-pools/${tenantId}/${id}`));
